



























































































import {Vue, Component} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'

import {ProfileState} from '@/store/modules/profile'

import {EventBus} from '@/main'
import Locate, {Position} from '@/lib/location'
import {ReservationResponse} from '@/lib/kepler/interfaces'
import ServiceMesh from '@/lib/serviceMesh'
import Utils from '@/utils'

import MapStyles from '@/lib/map/styles/MapStyles'
import {PopupState} from '@/store'
import MapFiltersWrapper from '@/components/filters/MapFiltersWrapper.vue'
import {Filter, MapFiltersState} from '@/store/modules/map'

interface MarkerLabel {
  color?: string
  fontFamily?: string
  fontSize?: string
  fontWeight?: string
  text: string
  origin?: [number, number]
}

interface ItemPosition {
  lat: number
  lng: number
}

interface Item {
  item: ReservationResponse
  position: ItemPosition
}

@Component({
  components: {
    MapFiltersWrapper,
    VehicleCardPopup: Utils.loadComponent('entities/vehicle/VehicleCardPopup'),
    CircleToggle: Utils.loadComponent('CircleToggle'),
    TopBar: Utils.loadComponent('TopBar'),
    Button: Utils.loadComponent('Button'),
    CustomIcon: Utils.loadComponent('CustomIcon'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Alert: Utils.loadComponent('proxy/Alert'),
    ParkingCardPopup: Utils.loadComponent('entities/vehicle/ParkingCardPopup'),
    ProgressCircular: Utils.loadComponent('proxy/ProgressCircular'),
    Layout: Utils.loadComponent('proxy/Layout'),
  },
})
export default class Map extends Vue {
  // Store mappings
  @State('profile') public profileState!: ProfileState
  @State((state) => state.configuration.appConfig?.default_latitude) public default_latitude?: number
  @State((state) => state.configuration.appConfig?.default_longitude) public default_longitude?: number
  @State((state) => state.booking.activeReservations) public activeReservationsState!: ReservationResponse[]
  @State('popupState') public popupState!: PopupState[]
  @State('filters') public filters!: MapFiltersState

  @Action('bookingFlush') public bookingFlush: any
  @Action('setUserPosition') public setUserPosition: any

  public gpsError: boolean = false
  public mapActive = false
  public centerPoint: Position = {
    lat: 0,
    lng: 0,
    acc: null,
  }
  public centerPointIcon = 'img/map/markers/POINTER.svg'
  public loading: boolean = false

  // Computed properties
  public get activeReservations() {
    const items: Item[] = []

    this.activeReservationsState.forEach((reservation: ReservationResponse) => {
      items.push({
        item: reservation,
        position: {
          lat: reservation.vehicle_slot.position.latitude,
          lng: reservation.vehicle_slot.position.longitude,
        },
      })
    })
    return items
  }

  public get mapStyle() {
    return MapStyles.getStyle(this.profileState.mapStyle ? this.profileState.mapStyle : 'default')
  }

  protected get mapOn() {
    return !this.popupState.length && this.mapActive
  }

  protected get layerMarkers() {
    return this.getLayer(this.filters.vehicles)
  }

  protected get parkingMarkers() {
    return this.getLayer(this.filters.park)
  }

  protected get zoneLayers() {
    return this.getLayer(this.filters.zones)
  }

  protected get clusteredPOI() {
    const p = this.filters.poi
    const obj: typeof p = {}
    for (const key in p) {
      if (p.hasOwnProperty(key) && p[key].active) {
        if (!(p[key] as any).visibility || (p[key] as any).visibility === 'normal') {
          obj[key] = p[key]
        }
      }
    }
    return obj
  }

  protected get unclusteredPOI() {
    const p = this.filters.poi
    const obj: typeof p = {}
    for (const key in p) {
      if (p.hasOwnProperty(key) && p[key].active) {
        if ((p[key] as any).visibility === 'important') {
          obj[key] = p[key]
        }
      }
    }
    return obj
  }

  protected get hasClusterable() {
    const layers = this.layerMarkers.length > 0
    const park = this.parkingMarkers.length > 0
    const poi = Object.keys(this.clusteredPOI).length
    return this.mapOn && (layers || park || poi)
  }

  protected getPolyLineColor(zone: string) {
    return ServiceMesh.getPolyLineColor(zone)
  }

  protected getLayer(f: Filter<any>) {
    let arr: any[] = []
    if (f && Object.keys(f).length) {
      for (const fKey in f) {
        if (f.hasOwnProperty(fKey)) {
          const f1 = f[fKey]
          if (f1.active) {
            arr = [...arr, ...f1.data]
          }
        }
      }
    }
    return arr
  }

  protected centerMap() {
    (this.$refs.map as any).pan(this.profileState.userPosition)
    // EventBus.$emit('recenter')
  }

  protected setupMap() {
    this.loading = true
    const defaultCenterPoint: Position = {
      lat: this.default_latitude || 0,
      lng: this.default_longitude || 0,
      acc: null,
    }
    return Locate.please_locate((pos) => {
      if (pos) {
        this.centerPoint = pos
        this.setUserPosition(pos)
        this.gpsError = false
      } else {
        this.centerPoint = defaultCenterPoint
        this.setUserPosition(defaultCenterPoint)
        this.gpsError = true
      }
      this.loading = false
      this.centerMap()
    })
  }

  protected parkingMarkerLabel(m: any): { label: MarkerLabel } {
    let available = m.parking_slots_availability.available
    available = available || ''
    const color = this.$vuetify.theme.PARKING ? this.$vuetify.theme.PARKING.toString() : ''
    return available ? {
      label: {
        text: available.toString(),
        fontSize: '10px',
        fontWeight: '600',
        color,
        origin: [23, 23.4],
      },
    } : {
      label: {
        text: ' ',
        origin: [15, 15],
      },
    }
  }

  // Lifecycle hooks
  protected mounted() {
    this.centerPoint = {
      lat: this.default_latitude || 0,
      lng: this.default_longitude || 0,
      acc: null,
    }
    this.$nextTick(() => {
      this.setupMap()
    })
  }

  protected activated() {
    this.mapActive = true; // TODO: figure out why these mofos are not activating at first load
    (this.$refs.map as any).refresh()
  }

  protected deactivated() {
    this.mapActive = false
  }

  protected keyBy(lat?: string | number, lng?: string | number, id?: string) {
    return ((id || '') + lat?.toString().slice(0, 8) + lng?.toString().slice(0, 8)).replace(/[.]/g, '').padEnd(22, 'X')
  }
}
